import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useParams } from 'react-router-dom';

//components
import { Container, Divider, Typography } from '@mui/material';
import SignInRegister from '../website/SignInRegister';
import PublicLayout from '../../layouts/PublicLayout';
import { CheckCircleOutlined } from '@mui/icons-material';
import nodeAxiosFirebase from '../../utils/nodeAxiosFirebase';

const Welcome = () => {
  const { t } = useTranslation();
  const { businessId } = useParams();
  const [businessData, setBusinessData] = useState({});
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchBusinessData = async () => {
      if (businessId) {
        try {
          const data = await nodeAxiosFirebase({
            t,
            method: 'GET',
            url: `public/business?businessId=${businessId}`,
            noAuth: true,
            body: {},
          });

          setBusinessData(data?.data);
          localStorage.setItem('businessId', businessId);
          localStorage.setItem('businessName', data?.data?.business?.name);
          if (data?.data?.business?.mainColor !== undefined) {
            localStorage.setItem('mainColor', data?.data?.business?.mainColor);
            localStorage.setItem('secColor', data?.data?.business?.secColor);
          }
        } catch (error) {
          console.error('Error fetching business data:', error);
        }
      }
    };

    fetchBusinessData();
  }, [businessId]);

  const onCreation = () => {
    setSuccess(true);
  };

  return (
    <PublicLayout>
      <div>
        {success ? (
          <Container style={{ marginTop: '200px' }}>
            <div>
              <CheckCircleOutlined
                style={{ fontSize: '100px', marginBottom: '25px' }}
                color="success"
              />
            </div>
            <Typography variant="h6" fontSize="14px" gutterBottom>
              {t('successEmployee')}
            </Typography>

          </Container>
        ) : (
          <Container>
            <div className="mt-4" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>

              <div
                style={{ width: '480px', textAlign: 'center' }}
                className="mt-1 mb-1 align-c"
              >

                <div style={{ width: '480px' }} className='align-c mt-5'>
                  <img src={'https://cdn.prod.website-files.com/689f4d092f407e2fb7f28abb/68a73324d2e3fb5fa7634eaa_logo-node.png'} alt="logo" style={{ width: '90px' }} />
                  <div className="mt-4">

                    <Typography
                      variant="h2"
                      fontSize="36px"
                      fontWeight={600}
                      color="textPrimary"
                    >
                      {businessData?.name}
                    </Typography>
                    <Typography
                      variant="h5"
                      fontSize="26px"
                      fontWeight={600}
                      color="textPrimary"
                    >
                      {t('welcomeEmployee')}
                    </Typography>

                    <Typography
                      variant="h5"
                      fontSize="13px"
                      fontWeight={400}
                      sx={{
                        marginTop: '10px',
                      }}
                      color="textPrimary"
                    >
                      {t('welcomeEmployeeText')}
                    </Typography>
                  </div>
                  <div className="mt-2">
                    <Divider component="div" />
                  </div>


                </div>
                <div className="mb-5 align-c" style={{ width: '480px', textAlign: 'center', }}>
                  <SignInRegister fromWelcome onCreation={onCreation} />
                </div>
              </div>

            </div>
          </Container>
        )}
      </div>
    </PublicLayout>
  );
};

export default Welcome;
